import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const services = [
  "AIDSClinicalTrials", "AdvancedDirectives",
  "BudgetCounseling", "BurialAssistance",
  "CaseManagement", "CareTeams",
  "Clothing", "DentalCare",
  "ContinuingEducation", "DrugAlcoholTreatment",
  "DomesticViolence", "FoodAssistance",
  "EmergencyShelter", "FoodStamps",
  "Employment", "LegalAssistance",
  "HIVEducation", "MedicalHIVSpecialtyCare",
  "HomeDeliveredMeals", "NutritionalCounseling",
  "HospiceServices", "PharmacyAssistance",
  "InformationAndReferral", "PostTestCounseling",
  "MentalHealthOutpatient", "RiskReductionCounseling",
  "NutritionSupplements", "SpiritualSupport",
  "Medicaid", "SSISSDI",
  "MedicalPrimaryCare", "SupportGroups",
  "Medicare", "TreatmentAdherence",
  "PartnerNotification" // Servicio sin par, se manejará en la tabla
];

const TableDomesticViolence = ({ updateServiceDate }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState({});
  const storedData = useSelector(state => state.profiles.Service);

  const handleChange = (service, type) => {
    setSelectedServices((prev) => {
      const newServices = { ...prev, [service]: prev[service] === type ? "" : type };
      updateServiceDate({ selectedServices: newServices });
      return newServices;
    });
  };

  useEffect(() => {
    setSelectedServices((prevData) => ({
        ...prevData,
        ...storedData
    }));
}, [storedData]);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Service")}</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Needs")}</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Receives")}</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Service")}</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Needs")}</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Receives")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: Math.ceil(services.length / 2) }, (_, i) => {
            const service1 = services[i * 2];
            const service2 = services[i * 2 + 1] || ""; // Evita errores con servicios impares
            return (
              <TableRow key={i}>
                {/* Primera columna */}
                <TableCell>{t(`Profiles.DomesticViolence.${service1}`)}</TableCell>
                <TableCell>
                  <Checkbox
                    color="primary"
                    checked={selectedServices[service1] === "Needs"}
                    onChange={() => handleChange(service1, "Needs")}
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    color="primary"
                    checked={selectedServices[service1] === "Receives"}
                    onChange={() => handleChange(service1, "Receives")}
                  />
                </TableCell>

                {/* Segunda columna (puede estar vacía si hay un número impar de servicios) */}
                {service2 ? (
                  <>
                    <TableCell>{t(`Profiles.DomesticViolence.${service2}`)}</TableCell>
                    <TableCell>
                      <Checkbox
                        color="primary"
                        checked={selectedServices[service2] === "Needs"}
                        onChange={() => handleChange(service2, "Needs")}
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        color="primary"
                        checked={selectedServices[service2] === "Receives"}
                        onChange={() => handleChange(service2, "Receives")}
                      />
                    </TableCell>
                  </>
                ) : (
                  <><TableCell></TableCell><TableCell></TableCell><TableCell></TableCell></>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableDomesticViolence;
